import React, { Component } from 'react';

import AuthenticatedApp from '../AuthenticatedApp';
import Aside from '../asideComponent/Aside';
import HeaderNav from '../headerNavComponent/HeaderNav';
import WithTableContentLoader from '../loadingComponent/WithTableContentLoader';
import WithDotsContentLoader from '../loadingComponent/WithDotsContentLoader';
import BaseConstants from '../../constants/BaseConstants';
import AppConfiguration from '../../assets/Configuration/ConfigurationFile.json';
import StateTag from '../tagComponent/StateTag/StateTag';

const Tag = React.lazy(() => import('../tagComponent/Tag'));
const Field = React.lazy(() => import('../fieldComponent/Field'));
const Group = React.lazy(() => import('../groupComponent/Group'));
const User = React.lazy(() => import('../userComponent/User'));
const AssetsContainer = React.lazy(() => import('../wellComponent/AssetsContainer'));
const Home = React.lazy(() => import('../Home'));
const Producers = React.lazy(() => import('../producerComponent/Producers'));
const MachineLearning = React.lazy(() => import('../machineLearningComponent/MachineLearning'));
const EspHealth = React.lazy(() => import('../espHealthComponent/EspHealth'));
const LutzTemplatesComponent = React.lazy(() => import('../lutzComponent/LutzTemplatesComponent'));
class Page extends Component {
  constructor(props) {
    super(props);
    this.logoName = require(`../../assets/img/brand/${AppConfiguration.logoName}`);
    this.state = {
      isLoading: true,
    };
    this.isLoading = this.isLoading.bind(this);
  }

  isLoading() {
    this.setState({ isLoading: !this.state.isLoading });
  }

  getPageFooter() {}

  render() {
    let component = (
      <WithDotsContentLoader>
        <Home loading={this.isLoading} isLoading={this.state.isLoading} />
      </WithDotsContentLoader>
    );
    if (AppConfiguration.clientName !== 'dmz') {
      switch (window.location.pathname) {
        case '/wlmgAllWells':
          component = (
            <WithTableContentLoader>
              <AssetsContainer
                liftType={BaseConstants.ALL_DEVICE_TYPES_LIFT_TYPE_KEY}
                loading={this.isLoading}
                isLoading={this.state.isLoading}
              />
            </WithTableContentLoader>
          );
          break;
        case '/wlmgGeneric':
          component = (
            <WithTableContentLoader>
              <AssetsContainer
                liftType={BaseConstants.GENERIC_DEVICE_TYPES_LIFT_TYPE_KEY}
                loading={this.isLoading}
                isLoading={this.state.isLoading}
              />
            </WithTableContentLoader>
          );
          break;
        case '/wlmgEsp':
          component = (
            <WithTableContentLoader>
              <AssetsContainer
                liftType={BaseConstants.ESP_DEVICE_TYPES_LIFT_TYPE_KEY}
                loading={this.isLoading}
                isLoading={this.state.isLoading}
              />
            </WithTableContentLoader>
          );
          break;
        case '/wlmgSrp':
          component = (
            <WithTableContentLoader>
              <AssetsContainer
                liftType={BaseConstants.SRP_DEVICE_TYPES_LIFT_TYPE_KEY}
                loading={this.isLoading}
                isLoading={this.state.isLoading}
              />
            </WithTableContentLoader>
          );
          break;
        case '/wlmgSkid':
          component = (
            <WithTableContentLoader>
              <AssetsContainer
                liftType={BaseConstants.SKID_DEVICE_TYPES_LIFT_TYPE_KEY}
                loading={this.isLoading}
                isLoading={this.state.isLoading}
              />
            </WithTableContentLoader>
          );
          break;
        case '/wlmgHorizPump':
          component = (
            <WithTableContentLoader>
              <AssetsContainer
                liftType={BaseConstants.HORIZ_PUMP_DEVICE_TYPES_LIFT_TYPE_KEY}
                loading={this.isLoading}
                isLoading={this.state.isLoading}
              />
            </WithTableContentLoader>
          );
          break;
        case '/wlmgTags':
          component = (
            <WithTableContentLoader>
              <Tag loading={this.isLoading} isLoading={this.state.isLoading} />
            </WithTableContentLoader>
          );
          break;
        case '/wlmgStateTags':
          component = (
            <WithTableContentLoader>
              <StateTag loading={this.isLoading} isLoading={this.state.isLoading} />
            </WithTableContentLoader>
          );
          break;
        case '/wlmgFields':
          component = (
            <WithTableContentLoader>
              <Field loading={this.isLoading} isLoading={this.state.isLoading} />
            </WithTableContentLoader>
          );
          break;
        case '/wlmgProducers':
          component = (
            <WithTableContentLoader>
              <Producers loading={this.isLoading} isLoading={this.state.isLoading} />
            </WithTableContentLoader>
          );
          break;
        case '/wlmgGroups':
          component = (
            <WithTableContentLoader>
              <Group loading={this.isLoading} isLoading={this.state.isLoading} />
            </WithTableContentLoader>
          );
          break;
        case '/wlmgUsers':
          component = (
            <WithTableContentLoader>
              <User loading={this.isLoading} isLoading={this.state.isLoading} />
            </WithTableContentLoader>
          );
          break;
        case '/wlmgML':
          component = (
            <WithTableContentLoader>
              <MachineLearning loading={this.isLoading} isLoading={this.state.isLoading} />
            </WithTableContentLoader>
          );
          break;
        case '/wlHealth':
          component = (
            <WithTableContentLoader>
              <EspHealth loading={this.isLoading} isLoading={this.state.isLoading} />
            </WithTableContentLoader>
          );
          break;
        case '/wlmgLutz':
          component = (
            <WithTableContentLoader>
              <LutzTemplatesComponent loading={this.isLoading} isLoading={this.state.isLoading} />
            </WithTableContentLoader>
          );
          break;
        default:
          break;
      }
    } else {
      switch (window.location.pathname) {
        case '/wlmgML':
          component = (
            <WithTableContentLoader>
              <MachineLearning loading={this.isLoading} isLoading={this.state.isLoading} />
            </WithTableContentLoader>
          );
          break;
        default:
          break;
      }
    }

    return (
      <div
        className={
          this.state.isLoading ? 'wrapper' : 'wrapper loader modal-backdrop fade show bg-white loader-bg-position'
        }
      >
        <div>
          <HeaderNav />
        </div>
        {window.location.pathname !== '/wlmgHome' ? (
          <aside className="main-sidebar">
            <Aside />
          </aside>
        ) : (
          ''
        )}
        <div className="content-wrapper" style={window.location.pathname === '/wlmgHome' ? { marginLeft: '0px' } : {}}>
          {component}
        </div>
        <footer className="main-footer" style={window.location.pathname === '/wlmgHome' ? { marginLeft: '0px' } : {}}>
          {/* {
            <div>
              <span className="copyright">Powered by Intelevate&nbsp; © {new Date().getFullYear()}. All Rights Reserved</span>
            </div>
          } */}

          {AppConfiguration.clientName === 'endurance' ? (
            <span className="copyright">
              Powered By Endurance Digital Solutions © {new Date().getFullYear()}. All Rights Reserved.
            </span>
          ) : AppConfiguration.clientName === 'alitheflow' ? (
            <span>Intelligence in Motion, Insights Delivered. Powered By CGC Technologies</span>
          ) : (
            <>
              Copyright &copy; {new Date().getFullYear()} {/* <a href="http://www.evinsys.com/">EVINSYS Inc</a> */}. All
              Rights Reserved. Powered by{' '}
              <>
                {AppConfiguration.logo_powered_by ? (
                  <img
                    src={require(`../../assets/img/brand/${AppConfiguration.logo_powered_by}`)}
                    style={{ height: '0.7rem', width: 'auto', marginLeft: '0.2rem' }}
                  />
                ) : (
                  <>
                    <span className="well">Opti</span>
                    <span className="lynx">Lynx</span>
                    <span>.</span>
                  </>
                )}
              </>
            </>
          )}

          {AppConfiguration.docTitle === 'DriveLynx' && (
            <>
              <a target="blank" className="footer-link" href="https://aid.welllynx.com/">
                DriveLynx
              </a>
              &nbsp;Copyright © {new Date().getFullYear()} AID. All Rights Reserved.
            </>
          )}
        </footer>
        <div className="control-sidebar-bg" />
      </div>
    );
  }
}

export default AuthenticatedApp(Page);
